import { render, staticRenderFns } from "./ConfigSaveVehicleModal.vue?vue&type=template&id=2b8bd9b5&scoped=true"
import script from "./ConfigSaveVehicleModal.vue?vue&type=script&lang=js"
export * from "./ConfigSaveVehicleModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigSaveVehicleModal.vue?vue&type=style&index=0&id=2b8bd9b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8bd9b5",
  null
  
)

export default component.exports